import React, { createContext, useContext, useState } from "react";
import { Snackbar, Alert } from "@mui/material";

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    message: null,
    type: "info",
  });
  const [open, setOpen] = useState(false);

  const showNotification = (message, type = "info") => {
    setNotification({ message, type });
    setOpen(true);
    setTimeout(() => {
      setOpen(false);
    }, 2000); // 2-second duration
  };

  const closeNotification = () => {
    setOpen(false);
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {children}
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={closeNotification}
      >
        <Alert
          severity={notification.type}
          onClose={closeNotification}
          variant="filled"
        >
          {notification.type ==="error" ? notification.message?.response?.data?.error?.message || "فعلا در دسترس نیستیم، به زودی برمیگردیم" : notification.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => useContext(NotificationContext);
